import { Box, Typography } from "@mui/material";

import { useGetAllProductsQuery } from "api/memberPortal/project/product/product.api";
import { Product } from "api/memberPortal/project/product/product.types";

interface IsResubmissionProps {
  productForm: any;
}

const IsResubmissionSection = ({ productForm }: IsResubmissionProps) => {
  const { data: allVids = [] } = useGetAllProductsQuery();
  const vidOptions = (allVids as Product[])
    .filter(
      (prod) =>
        !prod.previous_vid?.some(
          (productVid: {
            previous_product?: { v_id: number };
            active: boolean;
          }) =>
            productVid.previous_product?.v_id === prod.v_id &&
            productVid.active === true,
        ),
    )
    .map((prod) => ({ value: prod.v_id, label: "VID" + prod.v_id }));

  return (
    <Box className="mb-4">
      {/* WARN: Custom styling from pre standardization! */}
      {/* TODO: Standardize when you come across this!  */}
      <Typography variant="body1" className="mb-2">
        PRODUCT SUBMISSION TYPE
      </Typography>
      <div className="border p-3 rounded">
        <productForm.AppField
          name="submissionType.is_resubmission"
          listeners={{
            onChange: ({ value }: { value: boolean }) => {
              !value && productForm.resetField("submissionType.previous_vid");
            },
          }}
        >
          {(isResubmissionField: any) => (
            <>
              <isResubmissionField.BooleanRadioButton
                options={[
                  { label: "New Product Submission", value: false },
                  { label: "Product Re-Submission", value: true },
                ]}
                label="Select if this product is a new product submission, or if this product is a resubmission from a previously terminated/withdrawn product."
                isHorizontal={true}
                required
                onChange={(value: boolean) => {
                  if (value) {
                    // Auto-set publish_status to Unpublished when resubmission is selected
                    productForm.setFieldValue("publish_status", "Unpublished");
                  }
                }}
              />
              {isResubmissionField.state.value && (
                <Box sx={{ marginTop: 2 }}>
                  <productForm.AppField name="submissionType.previous_vid">
                    {(field: any) => (
                      <field.MultiAutocompleteSelect
                        options={vidOptions}
                        label="Indicate all previously terminated or withdrawn VIDs:"
                        style={{ width: "60%" }}
                        size="small"
                      />
                    )}
                  </productForm.AppField>
                </Box>
              )}
            </>
          )}
        </productForm.AppField>
      </div>
    </Box>
  );
};

export default IsResubmissionSection;
